import type { Theme } from "@mui/material";

const MuiAppBar = (theme: Theme) => ({
  colorDefault: {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.secondary,
  },
});

export default MuiAppBar;
